import { Component } from 'preact'
import cx from 'classnames'

import Cols from '../../cols/cols'
import Col from '../../cols/col'
import { Caption } from '../../textNodes'
import Factoid from '../../factoid/factoid'
import { birmanize, pluralize } from 'lib/textHelper'
import { moscowifyLocal } from '../../calendar/timezoneUtils'

export default class NewPaybarVacancyPublicationsStatus extends Component {
  get remainingPublications() {
    return this.subscription.remainingPublications
  }

  get publicationLimitResetsInDays() {
    return this.subscription.publicationLimitResetsInDays
  }

  get maxPublications() {
    return this.subscription.maxPublications
  }

  get subscription() {
    return this.props.subscription
  }

  get remainingPublicationsLabel() {
    return pluralize(this.remainingPublications, 'Осталась', 'Остались', 'Осталось')
  }

  get remainingPublicationsCaption() {
    return `из ${this.maxPublications} публикаций в месяц`
  }

  get publicationLimitResetsInDaysLabel() {
    const dateInMsk = moscowifyLocal(new Date(this.subscription.publicationLimitResetsAt))
    const date = birmanize(dateInMsk, { format: 'dateOnly' })

    return `До перезарядки ${date}`
  }

  get publicationLimitResetsInDaysCaption() {
    return pluralize(this.publicationLimitResetsInDays, 'день', 'дня', 'дней')
  }

  get noPublicationsCaption() {
    const vacancies = pluralize(this.maxPublications, 'вакансия', 'вакансии', 'вакансий')

    return `Вы опубликовали <br />все ${this.maxPublications} ${vacancies} <br />в этом месяце`
  }

  render() {
    return (
      <Cols className={ cx('newPaybarVacancyPublicationsStatus', this.props.className) }>
        <Col>
          { this.remainingPublications > 0 &&
            <Factoid
              number={ this.remainingPublications }
              label={ this.remainingPublicationsLabel }
              caption={ this.remainingPublicationsCaption } />
          }
          { this.remainingPublications === 0 &&
            <Caption html={ this.noPublicationsCaption } className="error"/>
          }
        </Col>
        <Col>
          <Factoid
            number={ this.publicationLimitResetsInDays }
            label={ this.publicationLimitResetsInDaysLabel }
            caption={ this.publicationLimitResetsInDaysCaption } />
        </Col>
      </Cols>
    )
  }
}
